import Styles from './QuizForm.module.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Module imports
import { TextField, InputAdornment, Checkbox, FormControlLabel, FormControl, InputLabel, MenuItem, Select } from '@mui/material'; 
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

// Components import
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { useTranslation } from 'components/lib';
import InputFileUpload from '../UserManualForm/inputFileUpload';

// used in LMS and DIY QQ
export function QuizForm(
    {
        contentEditDetails,
        handleQuizUpload,
        setContentEditDetails,
        enableRandom = false,
        title,
        backButton = false,
        props
    }
) {

    const { t } = useTranslation();

    const emptyQuestion = {
        answer: "",
        options: [],
        question: "",
        questionType: "text",
        questionImage: null,
        uploadDone: false,


    }

    const navigate = useNavigate()

    const [quizQuestions, setQuizQuestions] = useState([])
    const addQuestion = (index) => {
        const newQuestion = { ...emptyQuestion, id: index }
        const updatedModulesList = [...quizQuestions, newQuestion];
        setQuizQuestions(updatedModulesList);
    }

    useEffect(() => {
        if (contentEditDetails?.action === "edit" && contentEditDetails?.source !== "") {
            setQuizQuestions(contentEditDetails?.source)
            return;
        }
        if (quizQuestions?.length === 0) {
            addQuestion(1)
        } else if (quizQuestions?.length === undefined) {
            setQuizQuestions([emptyQuestion])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentEditDetails])

    const handleQuizFormInputChange = (inputValue, field, index, optionsIndex = 0) => {
        setQuizQuestions(prevQuestions => {
            const updatedQuestions = [...prevQuestions];
            const updatedQuestion = { ...updatedQuestions[index] };
            if (field === 'options') {
                updatedQuestion[field][optionsIndex] = inputValue;
            } else if (field === 'upload') {
                updatedQuestion[field] = inputValue;
                updatedQuestion["uploadDone"] = true
            } else {
                updatedQuestion[field] = inputValue;
            }
            updatedQuestions[index] = updatedQuestion;
            return updatedQuestions;
        });
    };

    const markAnswer = (answer, index) => {
        if (answer) {
            setQuizQuestions(prevQuestions => {
                const updatedQuestions = [...prevQuestions];
                updatedQuestions[index].answer = answer;
                return updatedQuestions;
            });
        }
    };

    function handleDeleteItem(index) {
        const updatedQuizQuestion = quizQuestions.filter((_, i) => i !== index);
        setQuizQuestions([...updatedQuizQuestion]);
    }
    const handleQuestionTypeChange = (event, index) => {
        setQuizQuestions(prevQuestions => {
            const updatedQuestions = [...prevQuestions];
            const updatedQuestion = { ...updatedQuestions[index] };
            updatedQuestion.questionType = event.target.value;
            updatedQuestions[index] = updatedQuestion;
            return updatedQuestions;
        });
    };


    return (
        <div id='quizFormContainer' className={Styles.quizFormContainer}>
            <p id='quizTitle' className={Styles.quizTitle}>
                {title || t('Components.LMS.QuizForm.title')}
            </p>

            <div id='quizContainer' className={Styles.quizContainer}>
                {enableRandom &&
                    <div id='randOption' className={Styles.randOption}>
                        <p id='inputLabel' className={Styles.inputLabel}>
                            {t('Components.LMS.QuizForm.enableRandom.label')}
                        </p>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name='ordered'
                                    checked={!contentEditDetails.is_random}
                                    onClick={() => {
                                        setContentEditDetails(prev => ({
                                            ...prev,
                                            is_random: false
                                        }))
                                    }}
                                    label={t('Components.LMS.QuizForm.enableRandom.order.checkbox')}
                                />
                            }
                            labelPlacement="start"
                            label={t('Components.LMS.QuizForm.enableRandom.order.label')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name='random'
                                    checked={contentEditDetails.is_random}
                                    onClick={() => {
                                        setContentEditDetails(prev => ({
                                            ...prev,
                                            is_random: true
                                        }))
                                    }}
                                    label={t('Components.LMS.QuizForm.enableRandom.random.checkbox')}
                                />
                            }
                            labelPlacement="start"
                            label={t('Components.LMS.QuizForm.enableRandom.random.label')}
                        />
                    </div>
                }
                <p style={{ color: '#000', margin: '0.5em', fontSize: '0.8em' }}>
                    <span style={{ color: 'red' }} >*</span>
                    {t('Components.LMS.QuizForm.message')} </p>
                {quizQuestions?.map((quesEntry, index) => (
                    <span
                        key={`${index}-quizQuest`}
                        style={{
                            color: "black",
                            marginLeft: "0.5em"
                        }}
                    >
                        <span style={{ display: 'flex', gap: '0.6em' }}>
                            <p>{t('Components.LMS.QuizForm.questions.delete', { index: index + 1 })}</p>
                            {index !== 0 && <button onClick={() => handleDeleteItem(index)}><FeatherIcon color="red" size='1em' icon='trash-2' /></button>}
                        </span>
                        <div
                            id={`${index}-quizQuest`}
                            className={Styles.quizGrid}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="question-type-label">{t('Components.LMS.QuizForm.questions.question.type.label')}</InputLabel>
                                <Select
                                    labelId="question-type-label"
                                    id={`${index}-question-type`}
                                    value={quesEntry.questionType || "text"}
                                    label={t('Components.LMS.QuizForm.questions.question.type.label')}
                                    onChange={(e) => handleQuestionTypeChange(e, index)}
                                    MenuProps={{ disableScrollLock: true }}
                                >
                                    <MenuItem value="text">{t('Components.LMS.QuizForm.questions.question.type.text')}</MenuItem>
                                    <MenuItem value="textAndImage">{t('Components.LMS.QuizForm.questions.question.type.textAndImage')}</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                id={`${index}-question`}
                                className={Styles.firstRowItem}
                                label={t('Components.LMS.QuizForm.questions.question.label')}
                                placeholder={t('Components.LMS.QuizForm.questions.question.placeHolder')}
                                fullWidth={false}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    maxLength: 50
                                }}
                                value={quesEntry.question || ''}
                                onChange={(e) => handleQuizFormInputChange(e.target.value, 'question', index)}
                            />
                            {quesEntry.questionType === 'textAndImage' && (
                                <div className={Styles.fileUploadContainer}>

                                    <InputFileUpload
                                        maxFileSize={23437}
                                        file={quesEntry?.upload}
                                        index={index}
                                        handleUMFormInputChange={handleQuizFormInputChange}
                                        imageFullUrl={quesEntry.imageUrl}
                                        className={Styles.fileUploadInput}
                                    />
                                </div>
                            )}
                            <div className={Styles.optionRow}>

                                {[1, 2, 3, 4].map((optionNumber, optIndex) => (
                                    <TextField
                                        key={`${index}-option-${optionNumber}`}
                                        required={optionNumber < 3}
                                        id={`${index}-option-${optionNumber}`}
                                        label={t('Components.LMS.QuizForm.questions.question.options.label', { optionNumber })}
                                        placeholder={optionNumber < 3 ?
                                            t('Components.LMS.QuizForm.questions.question.options.placeHolder.required', { optionNumber }) :
                                            t('Components.LMS.QuizForm.questions.question.options.placeHolder.optional', { optionNumber })}
                                        fullWidth={false}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            maxLength: 50,
                                            startAdornment: <InputAdornment position="start">
                                                <CheckCircleIcon
                                                    onClick={() => { markAnswer(quesEntry.options[optIndex], index) }}
                                                    sx={{
                                                        cursor: "pointer",
                                                        color: quesEntry.answer && quesEntry.options[optIndex] === quesEntry.answer ? "green" : "lightgrey"
                                                    }}
                                                />
                                            </InputAdornment>
                                        }}
                                        value={quesEntry.options[optIndex] || ''}
                                        onChange={(e) =>
                                            handleQuizFormInputChange(e.target.value, 'options', index, optIndex)
                                        }
                                    />
                                ))}
                            </div>
                            <p id={`helperText`}
                                className={`${Styles.firstRowItem} ${Styles.helperText}`}
                            >
                                {!quesEntry.answer.length ?
                                    t('Components.LMS.QuizForm.questions.question.helperText') : " "}
                            </p>
                        </div>
                    </span>
                ))}
            </div>
            <div
                id='quizBtnContainer'
                className={Styles.buttonsContainer}
            >
                <AivagamButton
                    id='cancelButton'
                    buttonText={t('Components.LMS.QuizForm.button.close')}
                    onClick={() => {
                        if (backButton) {
                            navigate(-1)
                        } else {
                            setContentEditDetails({
                                type: "",
                                lectureID: "",
                                action: "",
                                lectureIndex: -1,
                                source: ""
                            })
                        }
                    }}
                    type="cancel"
                />
                <AivagamButton
                    id='addButton'
                    buttonText={t('Components.LMS.QuizForm.button.add')}
                    onClick={() => { addQuestion(quizQuestions?.length + 1) }}
                    type="action"
                    disabled={quizQuestions?.length === 20}
                />
                <AivagamButton
                    id='confirmButton'
                    buttonText={contentEditDetails?.action === "edit" ?
                        t('Components.LMS.QuizForm.button.update') :
                        t('Components.LMS.QuizForm.button.save')}
                    onClick={() => {
                        if (enableRandom) {
                            handleQuizUpload(quizQuestions, contentEditDetails.is_random)
                        } else {
                            contentEditDetails?.action === "edit" ?
                                handleQuizUpload(quizQuestions, "PATCH")
                                : handleQuizUpload(quizQuestions, "POST")
                        }
                    }}
                    type="confirm"
                    disabled={(!quizQuestions?.every(entry => Boolean(entry.answer.trim())) || quizQuestions?.length < 5)}
                    tooltipText={quizQuestions?.length < 5 ? t('Components.LMS.QuizForm.button.helperText') : ""}
                />
            </div>
        </div>
    )
}